import React from 'react';
export function Footer() {
  return <footer className="w-full bg-navy-deep px-4 pb-32 pt-10 text-center text-white/60" data-id="element-120" data-mp="32wmqrybuniwl">
      <p className="font-display text-lg font-bold uppercase tracking-wide text-white" data-id="element-121" data-mp="3ggtymjf7hl5r">
        Pediatric Orthodontic Case Decision Blueprint™
      </p>
      <p className="mt-1 text-sm" data-id="element-122" data-mp="36p6buvtlgsam">Created by Dr. Valeria Montes</p>
      <p className="mt-1 text-sm" data-id="element-123" data-mp="36nd5lhmw8a35">© 2026 · All rights reserved.</p>
      <nav aria-label="Legal" className="mt-4 flex justify-center gap-4 text-sm" data-id="element-124" data-mp="3ugbshd7czolz">
        <a href="#" className="hover:text-white" data-id="element-125" data-mp="38zbay6h7b62">Privacy Policy</a>
        <span aria-hidden="true" data-id="element-126" data-mp="3lecb2jsfmiii">|</span>
        <a href="#" className="hover:text-white" data-id="element-127" data-mp="3ldanjfu8c3jw">Terms of Use</a>
        <span aria-hidden="true" data-id="element-128" data-mp="3qd6qrcv3rqye">|</span>
        <a href="#" className="hover:text-white" data-id="element-129" data-mp="3qc40961ozqj0">Contact</a>
      </nav>
    </footer>;
}